import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import Avatar from '@/src/components/common/Avatar/Avatar';
import Select from '@/src/components/common/Select/Select';

@connect((store) => {
  return {
    workstreams: store.workstreams,
  };
})
class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchIsLoading: false,
      searched: [],
    };
  }

  render() {
    const { options } = this.props;

    const handleSelectMember = (value) => {
      if (this.props.onSelect) {
        this.props.onSelect(value.others);
      }
    };

    return (
      <Select
        showSelectedInInput={false}
        isSearchable={true}
        isClose={this.props.isClose}
        isLoading={this.state.searchIsLoading}
        placeholder={`Add access to specific users`}
        classes={{ options: 'searchMemberContainer' }}
        options={options}
        exclude={this.props.exclude}
        renderOption={(option) => (
          <div className="memberOption">
            <div className="memberMainDetails">
              <Avatar
                name={option.label}
                disableTooltip={true}
                image={
                  option.others.avatar !== 'default.png'
                    ? `${this.props.avatarBaseUrl}${option.others.avatar}`
                    : null
                }
              />
              <span>{option.label}</span>
            </div>
            <div className="memberRole">
              <span>{option.others.role}</span>
            </div>
          </div>
        )}
        onChange={handleSelectMember}
      />
    );
  }
}

export default Search;
